import { env } from "./get";

export { loadEnv, clientEnvString } from "./load";
export default env;
